export default __webpack_public_path__ + "static/security_compliance_updated-e5656b9ae81ad92dcdaac50e46e29a80.png";